import { ReactNode, useState, useEffect } from 'react';
import PlatformHeader from './PlatformHeader/PlatformHeader';
import PlatformNav from './PlatformNav/PlatformNav';

const PlatformShell = ({ children }: { children?: ReactNode }): JSX.Element => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [bannerHeight, setBannerHeight] = useState<string>('0px');

  useEffect(() => {
    const checkIntercomBanner = (mutations: MutationRecord[]) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          const banner = node as HTMLIFrameElement | HTMLButtonElement;
          if (banner.name === 'intercom-banner-frame') {
            const interval = setInterval(() => {
              // const { height } = banner.getBoundingClientRect();
              // const newHeight = height > 0 ? `${height}px` : '0px';
              const computedStyle = window.getComputedStyle(document.body);
              const newHeight = computedStyle.getPropertyValue('margin-top');
              if (newHeight !== bannerHeight) {
                setBannerHeight(newHeight);
              } else if (newHeight !== '0px') {
                clearInterval(interval);
              }
            }, 25);
          }
        });
        mutation.removedNodes.forEach((node) => {
          const banner = node as HTMLIFrameElement | HTMLButtonElement;
          if (banner.name === 'intercom-banner-frame') {
            setBannerHeight('0px');
          }
        });
      });
    };

    // Set up observer
    const observer = new MutationObserver(checkIntercomBanner);

    // Observe changes in body
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, [bannerHeight]);

  return (
    <>
      <PlatformHeader
        onNavOpenClick={() => {
          setIsNavOpen(true);
        }}
        marginTop={bannerHeight}
      >
        {children}
      </PlatformHeader>

      <PlatformNav
        isOpen={isNavOpen}
        onOpenChange={(isOpen) => {
          setIsNavOpen(isOpen);
        }}
        marginTop={bannerHeight}
      />
    </>
  );
};

export default PlatformShell;
